module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Materials, tools and techniques")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flower")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paisley")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boho Toggle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Envelope Toggle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dotted Singleton")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kelly")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bow")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinket")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rivet")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunshine")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pod")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bottle-top")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garden")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cushion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crown")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shell")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wrapped Up")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘X’ Marks the Spot")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiral")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laced Up")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s note")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_002-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0